import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { Avatar, Box, Grid, Typography } from "@material-ui/core";

import userActions from "../actions";
import { useSelector } from "react-redux";
import { UserRoleText, USER_PROP } from "../constants";
import ReuseAction from "components/common/ReuseAction";

const useStyles = makeStyles((theme) => ({
  bold: {
    fontWeight: 600,
    marginRight: theme.spacing(1),
  },
  AvatarSmall: {
    marginRight: theme.spacing(2),
  },
  popoverItemDelete: {
    color: "#E16B66",
  },
}), { index: 999 });

const TableActions = () => {
  const classes = useStyles();
  const { editUser } = useSelector((s) => s.user);
  const { setDeleteConfirmationVisibility, openEditDialog } = userActions();

  const deleteRow = () => {
    setDeleteConfirmationVisibility(true);
  };
  const getActions = () => (
    <Box m={1}>
      <Grid container direction="column">
        <Button
          onClick={() => {
            openEditDialog();
          }}
          className={classes.popoverItem}
        >
          Edit profile setting
        </Button>
        <Button
          color="secondary"
          onClick={() => deleteRow()}
          className={classes.popoverItemDelete}
        >
          Remove
        </Button>
      </Grid>
    </Box>
  );
  const getMobileContent = () =>
    editUser[USER_PROP.FNAME] && (
      <Box p={3}>
        <Box m={2}>
          <Grid
            container
            justify="flex-start"
            alignItems="center"
            direction="row"
          >
            <Avatar className={classes.AvatarSmall}>
              {editUser[USER_PROP.FNAME][0]?.toUpperCase() +
                editUser[USER_PROP.LNAME][0]?.toUpperCase()}
            </Avatar>
            <Typography variant="h5">
              {`${editUser[USER_PROP.FNAME]} ${editUser[USER_PROP.LNAME]}`}
            </Typography>
          </Grid>
        </Box>
        <Box m={2}>
          <Grid
            container
            justify="flex-start"
            alignItems="center"
            direction="row"
          >
            <Typography className={classes.bold} variant="subtitle1">
              {"Role:"}
            </Typography>
            <Typography variant="subtitle1">
              {UserRoleText[editUser[USER_PROP.ROLE]]}
            </Typography>
          </Grid>
        </Box>
        <Box m={2}>
          <Grid
            container
            justify="flex-start"
            alignItems="center"
            direction="row"
          >
            <Typography className={classes.bold} variant="subtitle1">
              {"Email:"}
            </Typography>
            <Typography variant="subtitle1">
              {editUser[USER_PROP.EMAIL]}
            </Typography>
          </Grid>
        </Box>
      </Box>
    );
  return (
    <ReuseAction actions={getActions()} mobileContent={getMobileContent()} />
  );
};

export default TableActions;
